<template>
    <div>
        <go-top class="tap-top top-cls" :size=50 bg-color="#114734"></go-top>
    </div>
</template>

<script>
import GoTop from '@inotom/vue-go-top'
export default {
  components: {
    GoTop
  }
}
</script>
